import { useGlobalContext } from 'utilities';

const useLanguage = () => {
	const data = useGlobalContext();
	return { ...data[data.language ] };
};

export default useLanguage;
